import { getAnalytics } from "@tm/insurance/analytics";
import { CheckButton, H5Tag, LandingButton } from "@tm/static";
import React from "react";
import { HorizontalDivider } from "../../pages/InsuranceLanding/InsuranceLanding.style";
import CommonModalDweb from "../CommonModalDweb/CommonModalDweb";
import FlexComp from "../FlexComp/FlexComp";
import FormattedText from "../FormattedText/FormattedText";
import { ImageComponent } from "../ImageComponent/ImageComponent";
import AnchorTag from "../TextStyles/AnchorTag";
import ParaTag from "../TextStyles/ParaTag";
import SpanTag from "../TextStyles/SpanTag";
import { IAgentAgreementSection } from "../TravelDetails/types";
import { TermsAndConditions } from "./AgentAgreementConsts";
import { BannerStyle, ConsentStyles } from "./AgentAgreementModal.style";

interface AgentAgreementProps {
  agentAgreementData: IAgentAgreementSection;
  showAgreementModal: boolean;
  setShowAgreementModal: (value: boolean) => void;
  onConstentClick: () => void;
}

const AgentAgreementModal: React.FC<AgentAgreementProps> = ({
  agentAgreementData,
  showAgreementModal,
  setShowAgreementModal,
  onConstentClick,
}) => {
  const [isSecond, setIsSecond] = React.useState(false);
  const [checkboxVal, setCheckboxVal] = React.useState(false);
  const analytics = getAnalytics();

  if (!showAgreementModal) {
    return null;
  } else {
    analytics?.trackLandingEvents({
      actionType: "Ins_DisclaimerPopUpShown",
    });
  }
  const { offeredBy, banner, consent, cta } = agentAgreementData;

  const customTitleComponent = offeredBy ? (
    <FlexComp gap="4px" alignItems="center" margin="5px 0 0 0">
      {offeredBy?.title && (
        <SpanTag fontWeight="bold">
          <FormattedText value={offeredBy?.title} />
        </SpanTag>
      )}
      {offeredBy?.icons?.map((url: string, index: number) => (
        <FlexComp gap="10px" key={index}>
          <ImageComponent
            height="22px"
            width="auto"
            src={url}
            loading="eager"
          />
          {index !== offeredBy?.icons?.length - 1 && (
            <HorizontalDivider
              height="22px"
              width="1px"
              backgroundColor="#979797"
            />
          )}
        </FlexComp>
      ))}
    </FlexComp>
  ) : null;

  function formatTextWithButtons(text: string) {
    const regex = /\{([^{}]+)\}(.*?)\{\/\1\}/g;

    const parts: (string | JSX.Element)[] = [];
    let lastIndex = 0;

    text.replace(regex, (match, tag, content, offset) => {
      if (lastIndex < offset) {
        parts.push(text.slice(lastIndex, offset));
      }
      parts.push(
        <span
          style={{ color: "#008CFF" }}
          onClick={() => {
            analytics?.trackLandingEvents({
              actionType: "Ins_DisclaimerClicked",
            });
            setIsSecond(true);
          }}
        >
          {content}
        </span>
      );
      lastIndex = offset + match.length;
      return "";
    });
    if (lastIndex < text.length) {
      parts.push(text.slice(lastIndex));
    }

    return parts;
  }

  const customTitleComponentBack = (
    <AnchorTag
      handleClick={() => {
        analytics?.trackLandingEvents({
          actionType: "Ins_DisclaimerBackClicked",
        });
        setIsSecond(false);
      }}
      fontSize="xs"
      fontWeight="700"
      color="black"
      margin="5px 0 0 0"
    >
      <FormattedText value={"< Back"} />
    </AnchorTag>
  );

  return (
    <>
      {!isSecond && (
        <CommonModalDweb
          handleClick={() => {
            analytics?.trackLandingEvents({
              actionType: "Ins_DisclaimerClosed",
            });
            setShowAgreementModal(false);
          }}
          customTitleComponent={customTitleComponent}
          customWidth="640px"
        >
          {banner && banner.description && (
            <BannerStyle backgroundColor={banner?.backgroundColor}>
              <FormattedText value={banner?.description} />
            </BannerStyle>
          )}
          {consent && (
            <ConsentStyles>
              {consent.text &&
                consent.text.map((text: string, index: number) => (
                  <CheckButton
                    inputId="confirmTnC"
                    handleChange={() => {
                      analytics?.trackLandingEvents({
                        actionType: `${
                          checkboxVal
                            ? `Ins_DisclaimerCheckBoxUnchecked`
                            : `Ins_DisclaimerCheckBoxChecked`
                        }`,
                      });
                      setCheckboxVal(!checkboxVal);
                    }}
                    margin="0 0 24px 0 "
                    isChecked={checkboxVal}
                  >
                    {formatTextWithButtons(text)}
                  </CheckButton>
                ))}
            </ConsentStyles>
          )}
          {cta && (
            <>
              {cta.text && (
                <LandingButton
                  customTitle={cta.text}
                  disableState={!checkboxVal}
                  customWidth="100%"
                  onClick={onConstentClick}
                />
              )}
              {cta.description && (
                <ParaTag color="#4a4a4a" margin="12px 0 0 0">
                  <FormattedText value={cta.description} />
                </ParaTag>
              )}
            </>
          )}
        </CommonModalDweb>
      )}
      {isSecond && (
        <CommonModalDweb
          handleClick={() => {
            analytics?.trackLandingEvents({
              actionType: "Ins_DisclaimerClosed",
            });
            setShowAgreementModal(false);
            setIsSecond(false);
          }}
          customTitleComponent={customTitleComponentBack}
          customWidth="640px"
        >
          <H5Tag margin="0 0 16px 0">
            <FormattedText value={TermsAndConditions.heading} />
          </H5Tag>
          <ParaTag margin="0 0 16px 0">
            <div
              dangerouslySetInnerHTML={{ __html: TermsAndConditions.body }}
            />
          </ParaTag>
        </CommonModalDweb>
      )}
    </>
  );
};
export default AgentAgreementModal;
